import { combineReducers } from '@reduxjs/toolkit';
import country from './countrySlice';
import frontend from './frontendSlice';

const sharedReducers = combineReducers({
	country,
	frontend,
});

export default sharedReducers;
